const MinusOutlined = () => {
    return <span className='minusOutlined-icon' />;
};

export default MinusOutlined;
